import { rateDiscriminator } from "./rate-discriminator.const";

export const rateDiscriminatorLabel: Record<string, string> = {
  [rateDiscriminator.fcl]: "FCL Linked",
  [rateDiscriminator.fclFlat]: "FCL Flat",
  [rateDiscriminator.fclPickupDelivery]: "FCL Pickup - Delivery",
  [rateDiscriminator.lcl]: "LCL Linked",
  [rateDiscriminator.lclFlat]: "LCL Flat",
  [rateDiscriminator.air]: "Air Linked",
  [rateDiscriminator.airFlat]: "Air Flat",
  [rateDiscriminator.ftl]: "FTL",
  [rateDiscriminator.ftlFlat]: "FTL Flat",
  [rateDiscriminator.ptl]: "PTL",
  [rateDiscriminator.ptlFlat]: "PTL Flat",
  [rateDiscriminator.ltl]: "LTL Terminal - Terminal",
  [rateDiscriminator.ltlFlat]: "LTL Flat",
  [rateDiscriminator.ltlPickupDelivery]: "LTL Pickup - Delivery",
  [rateDiscriminator.ltlLinked]: "LTL Linked Transit",
};
